import { render, staticRenderFns } from "./ModalStudentEdit.vue?vue&type=template&id=28b29364&scoped=true&lang=pug&"
import script from "./ModalStudentEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentEdit.vue?vue&type=style&index=0&id=28b29364&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b29364",
  null
  
)

export default component.exports